// Site-wide SEO constants
export const SITE_URL = 'https://zeevalife.com';
export const SITE_NAME = 'ZEEVA Life';
export const SITE_TWITTER = '@zeeva_living';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og-default.jpg`;
export const DEFAULT_TWITTER_CARD = 'summary_large_image';
export const DEFAULT_DESCRIPTION =
  'ZEEVA Life — evidence-based exercise, rehabilitation, mobility and lifestyle strategies designed to help individuals build strength, preserve mobility and extend vitality throughout life.';

export const ORGANIZATION_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'HealthAndBeautyBusiness',
  name: 'ZEEVA Life',
  alternateName: 'Zeeva Life',
  url: SITE_URL,
  logo: `${SITE_URL}/images/zeeva-logo.png`,
  description: DEFAULT_DESCRIPTION,
  slogan: 'Strength • Health • Longevity',
  address: {
    '@type': 'PostalAddress',
    addressLocality: 'Mumbai',
    addressRegion: 'Maharashtra',
    addressCountry: 'IN',
  },
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '+91-97309-84048',
    contactType: 'customer service',
    email: 'healwith@zeevalife.com',
    availableLanguage: ['en', 'hi'],
  },
  sameAs: ['https://instagram.com/zeeva_living'],
};
